import React from 'react';

import { Link, NavLink } from 'react-router-dom';
import { stretchCardStyles } from './styles';
import { LogoAvatar } from '../LogoAvatar';
import StyledFlexDirection from '../StyledFlexDirection';
import  cloneDeep from 'lodash/cloneDeep';
import BackgroundGradient from '../DivStyleAdders/BackgroundGradient';
import { ModuleList } from '../ModuleList';

/*

StyleProps:
• backgroundImageURL
• avatarURL

Props:
• logoURL
• typeTitleText
• mainTitleText
• subTitleText
• firstIcon
• secondIcon
• hoverIcons
• cardImageHeight
• cardTypeTitleColor
• fontSizeDivider
• price

*/

const _applyStyleModifiers = (props) => {
    const { logoURL, size } = props;
    const clonedStyles = cloneDeep(stretchCardStyles);
    const { cardBackgroundImage } = clonedStyles; 
    
    if (props.cardImageHeight) {
        cardBackgroundImage.height = props.cardImageHeight;
    }

    return { ...clonedStyles, cardBackgroundImage };
}

export const StretchCard = (props) => {
    
    const styles = _applyStyleModifiers(props);

    // Style Overrides
    styles.cardBackgroundImage.backgroundImage = (props.backgroundImageURL) ? `url(${props.backgroundImageURL})` : styles.cardBackgroundImage.backgroundImage;
    styles.cardBackgroundImage.height = (props.cardSizeHeight) ? `url(${props.cardSizeHeight})` : styles.cardBackgroundImage.height;
    styles.cardBackgroundImage.width = (props.cardSizeWidth) ? `url(${props.cardSizeWidth})` : styles.cardBackgroundImage.width;
    styles.cardTypeTitle.color = (props.cardTypeTitleColor) ? props.cardTypeTitleColor : styles.cardTypeTitle.color;
    styles.cardTypeTitle.fontSize = (props.fontSizeDivider) ?  styles.cardTypeTitle.fontSize / props.fontSizeDivider : styles.cardTypeTitle.fontSize;
    styles.cardMainTitle.fontSize = (props.fontSizeDivider) ?  styles.cardMainTitle.fontSize / props.fontSizeDivider : styles.cardMainTitle.fontSize;
    styles.cardSubTitle.fontSize = (props.fontSizeDivider) ?  styles.cardSubTitle.fontSize / props.fontSizeDivider : styles.cardSubTitle.fontSize;
    styles.cardSubTitlePrice.fontSize = (props.fontSizeDivider) ?  styles.cardSubTitlePrice.fontSize / props.fontSizeDivider : styles.cardSubTitlePrice.fontSize;
    styles.cardMainTitlePrice.fontSize = (props.fontSizeDivider) ?  styles.cardMainTitlePrice.fontSize / props.fontSizeDivider : styles.cardMainTitlePrice.fontSize;
    styles.container.marginBottom = (props.marginBottom) ?  props.marginBottom : styles.container.marginBottom;

    return (
        <div>
            <div style={ styles.container }>
                <Link 
                    onClick={() => window.scrollTo(0, 0)}
                    to={`${props.linkURL}`}
                    style={{ textDecoration: 'none' }}>
                        <div style={ styles.cardBackgroundImage }>
                            
                            <BackgroundGradient gradient={ props.cardOverlayPrice ? true : false}>
                                <div style={ styles.cardSpaceBetween }>
                                    {props.logoURL && <LogoAvatar 
                                        size={ 90 }
                                        style={ styles.avatarStyle } 
                                        imageURL={ props.avatarURL } 
                                        logoURL={ props.logoURL }
                                    />}
                                
                                    <div style={ styles.cardButtonOptionContainer }>
                                        <div>
                                            <span style={ styles.cardOverlayPrice }>{props.cardOverlayPrice}</span>
                                            {/* <HoverIconLink style={styles.cardButtonOption} hoverIconStyle={'black'} defaultIconStyle={'blue'} href="#" style={styles} icon="s15" /> */}
                                            {/* <a href="#">
                                                <i
                                                style={styles.cardButtonOption} 
                                                className={`fa fa-${props.firstIcon} ${props.hoverIcons && "hoverIcon"}` || "fa fa-heart"}>
                                                </i>
                                                </a>
                                                <a href="#">
                                                <i 
                                                style={styles.cardButtonOption} 
                                                className={`fa fa-${props.secondIcon} ${props.hoverIcons && "hoverIcon"}` || "fa fa-heart"}>
                                                </i>
                                            </a> */}
                                        </div>
                                    </div>
                                </div>

                            </BackgroundGradient>
                        </div>
                </Link>
                
                <span style={ styles.cardTypeTitle }>
                    { props.typeTitleText }
                </span>
                <StyledFlexDirection flexDirection={props.flexDirection}>
                    <Link 
                        to={`${(props.linkPrefix) ? props.linkPrefix : ''}${props.linkURL}`}
                        style={{ textDecoration: 'none', marginTop: 8 / (props.fontSizeDivider) ? props.fontSizeDivider : 1 }}>
                            <span style={ styles.cardSubTitle }>
                                { props.subTitleText }
                            </span>
                            <span style={ styles.cardSubTitlePrice }>
                                { props.subTitlePrice }
                            </span>
                    </Link>
                    <Link 
                        to={`${(props.linkPrefix) ? props.linkPrefix : ''}${props.linkURL}`}
                        style={{ textDecoration: 'none', marginTop: 5 / (props.fontSizeDivider) ? props.fontSizeDivider : 1 }}>
                            <span style={ styles.cardMainTitle }>
                                { props.mainTitleText }
                            </span>
                            {/* <span style={ styles.cardMainTitlePrice }>
                                { props.mainTitlePrice }
                            </span> */}
                    </Link>
                </StyledFlexDirection>
            </div>
        </div> 
    );
};


// WEBPACK FOOTER //
// ./src/js/components/StretchCard/StretchCard.jsx